import { getMonth, getYear } from "date-fns";
import PropTypes from "prop-types";
import { useState } from "react";
import YearMonthDropDown from "./YearMonthDropDown";
import { Button } from "@mui/material";

export default function YearMonthDropDownWithButton({ buttonText = "", onClick, buttonProps }) {
  const [year, setYear] = useState(getYear(Date.now()));
  const [month, setMonth] = useState(getMonth(Date.now()));

  const handleMonthChange = (e) => {
    setYear(e.year);
    setMonth(e.month);
  };

  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <YearMonthDropDown onChange={handleMonthChange} />
      <Button sx={{ height: "55px" }} onClick={() => onClick(year, month)} {...buttonProps}>
        {buttonText}
      </Button>
    </div>
  );
}

YearMonthDropDownWithButton.propTypes = {
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  buttonProps: PropTypes.object,
};
